import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASEURL } from '../Config';

export const useTimelineData = (uuid, type, appliedFilters) => {
    const [entityName, setEntityName] = useState('');
    const [metadata, setMetadata] = useState(null);
    const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [managerOptions, setManagerOptions] = useState([]);
    const [purposeTypes, setPurposeTypes] = useState({});

    useEffect(() => {
        fetchPurposeTypes();
    }, []);

    useEffect(() => {
        if (uuid) {
            fetchTimelineData();
        }
    }, [uuid, appliedFilters]);

    const fetchPurposeTypes = () => {
        axios.get(`${BASEURL}/api/v1/purposeOfVisit`)
            .then(response => {
                const data = response.data || [];
                const map = {};
                data.forEach(p => {
                    map[p.label] = p;
                });
                setPurposeTypes(map);
            })
            .catch(error => {
                console.error("Error fetching purpose types:", error);
            });
    };

    const fetchTimelineData = () => {
        const payload = {
            visitorUUID: uuid,
            type: type,
            ...appliedFilters
        };
        
        // Remove empty filter values
        Object.keys(payload).forEach(key => {
            if (payload[key] === '') {
                delete payload[key];
            }
        });

        axios.post(`${BASEURL}/api/v1/salesManagerEvents/timelineForSchoolOrDistributor`, payload)
            .then(response => {
                const data = response.data.events;
                setEntityName(response.data?.visited || (type === 'school' ? 'School' : 'Distributor'));
                
                // Set metadata based on type
                if (type === 'school') {
                    setMetadata(response.data?.schoolMetadata || null);
                } else {
                    setMetadata(response.data?.distributorMetadata || null);
                }
                
                setEvents(data);
                setFilteredEvents(data);

                // Extract unique sales managers for filter
                const managerMap = new Map();
                data.forEach(e => {
                    if (e.salesManagerUUID && e.salesManager) {
                        managerMap.set(e.salesManagerUUID, e.salesManager);
                    }
                });
                const managers = Array.from(managerMap, ([uuid, name]) => ({ label: name, value: uuid }));
                setManagerOptions(managers);
            })
            .catch(error => {
                console.error("Error fetching timeline data:", error);
            });
    };

    return {
        entityName,
        metadata,
        events,
        filteredEvents,
        managerOptions,
        purposeTypes
    };
};
